import { ReactElement } from 'react';

import { ScheduleLayout } from 'layouts/schedule';

import { PatientAreaHomeTemplate } from 'templates/patient-area/PatientAreaHome';

import { ProtectedRoute } from 'components/wrappers/ProtectedRoute';

export default function PatientSelection() {
  return (
    <ProtectedRoute>
      <PatientAreaHomeTemplate />
    </ProtectedRoute>
  );
}

PatientSelection.getLayout = function getLayout(page: ReactElement) {
  return <ScheduleLayout>{page}</ScheduleLayout>;
};
